@if (isPopupActive()) {
    <div
        class="z-20 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50"
    >
        <div
            class="relative flex sm:flex-row flex-col justify-between bg-white shadow-md rounded-lg w-4/5 sm:w-3/5 h-1/2 sm:h-2/5 overflow-hidden text-black"
        >
            <div class="content-center w-full sm:w-1/2 ~p-4/8">
                <h1 class="mr-12 font-semibold ~text-xl/2xl">
                    {{ data().title }}
                </h1>
                <p>{{ data().subTitle }}</p>
                <app-newsletter-input-field></app-newsletter-input-field>
            </div>
            <img
                class="sm:self-end bg-primary sm:rounded-r-lg w-full sm:w-1/2 h-1/2 sm:h-full object-cover"
                src="{{
                    domHandler.getSmallestImageAsWebp(
                        data().newsletterPopupImage
                    )
                }}"
                [srcset]="
                    domHandler.generateSrcsetAsWebp(data().newsletterPopupImage)
                "
                alt="{{
                    data().newsletterPopupImage.alternativeText
                }} newsletter popup image"
                loading="lazy"
            />
            <div
                class="top-0 right-0 absolute content-center place-items-center bg-white rounded-bl-md size-12 cursor-pointer"
                (click)="hidePopup()"
                (click)="umami.track('newsletter-popup-close')"
            >
                <svg
                    class="size-8 text-black"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </div>
        </div>
    </div>
}
